<template>
  <div class="home-page">
    <Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img class="nav-icon-left" src="../../static/images/back.png" width="20"/>
        <div>{{ $t('Back') }}</div>
      </div>
    </div>
    <div class="mission-content ac crfff">
      <div class="fs50 mt50">{{productDetail.title}}</div>
      <div class="css-1asaykn mt40 faceimage-wrap">
        <div class="top-panel">
          <div class="top-panel-tabs">
            <div class="top-tab" :class="{active: topPanelTab === 'example'}" @click="topPanelTab = 'example'">{{ $t('ai_image') || 'AI Image' }}</div>
            <div class="top-tab" :class="{active: topPanelTab === 'desc'}" @click="topPanelTab = 'desc'">{{ $t('Guidance') || 'Guidance' }}</div>
          </div>
          <div class="top-panel-body">
            <div v-if="topPanelTab === 'example'" class="top-panel-example">
              <div class="sample-image-wrap">
                <img v-if="normalizedImage" :src="normalizedImage" class="sample-image" alt="sample" />
              </div>
            </div>
            <div v-else class="top-panel-desc">{{ $t('aiVividScene_desc') }}</div>
          </div>
        </div>

        <div class="upload-card mt30 mb30">
          <div class="upload-left">
            <label class="pick-photo-btn">
              <input accept="image/*" type="file" class="hidden-input" @change="convertToBase64_v2">
              <img class="pick-photo-icon" src="../../static/images/transparent.png" alt="" />
              <span>{{ $t('Upload') }}</span>
            </label>
            <div class="upload-hint fs22 cr999 mt10" v-if="!imageBase64">{{ $t('uploadTips') }}</div>
          </div>
          <div v-if="imageBase64" class="thumb-preview">
            <img :src="imageBase64" alt="preview" />
          </div>
        </div>

        <div class="ac mt50">
          <button class="generate-btn" :class="{disabled: !imageBase64}" :disabled="!imageBase64" @click="uploadImage">
            <strong>{{ $t('Generate') }}</strong>
          </button>
        </div>

        <div class="flex chances-info-bar mt30" style="justify-content: space-between;">
          <div class="score-badge">
            <span class="fs24">{{$t('ChancesLeft')}}</span>
            <span class="fs32 fw7 ml10">{{score}}</span>
          </div>
          <button class="buy-btn" @click="goPurchaseChances">
            <span>{{ $t('BuyChances') }}</span>
            <img src="../../static/images/buy.png" class="buy-icon" >
          </button>
        </div>
      </div>
    </div>
    <Dialog ref="imgDialog" :iscloseMask="true" :modalFoot="false" style="min-height: 300px;" title="" type="alert"
            width="100">
      <div slot="mdBox" class="alert-modal">
        <div class="close" style="text-align: right;margin: 0 auto;font-size: 50px;" @click="closeTmgDialog">×</div>
        <div v-if="imageShow" class="image ac">
          <div class="" style="font-size:0.3rem;margin-bottom: 20px;">{{ $t('downTips1') }}</div>
          <img v-if="isShowResult==1" :src="detail.url" style="width:80%;"/>
          <img v-if="isShowResult==2" :src="detail.original_url" style="width:80%;"/>

          <div class="tab mt50">
            <span :class="{'active':isShowResult==1}" @click="getResult(1)">{{ $t('Result') }}</span>
            <span :class="{'active':isShowResult==2}" @click="getResult(2)">{{ $t('Original') }}</span>
          </div>
          <div class="img-tools">
            <div class="ac disflex mt30">
              <div class="input-item">
                <div v-if="isShowResult==1" class="input-item2">
                  <input v-model="detail.url" class="input" disabled placeholder="" type="">
                  <img v-if="detail.url" id="copycode" :data-clipboard-text="detail.url"
                       src="../../static/images/Copy.png" style="margin-left: 10px;width: 1rem" @click="copy"/>
                </div>
                <div v-if="isShowResult==2" class="input-item2">
                  <input v-model="detail.original_url" class="input" disabled placeholder="" type="">
                  <img v-if="detail.original_url" id="copycode" :data-clipboard-text="detail.original_url"
                       src="../../static/images/Copy.png" style="margin-left: 10px;width: 1rem" @click="copy"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>


    <Dialog ref="processDialog" :iscloseMask="true" :modalFoot="false" style="min-height: 300px;" title="" type="alert"
            width="100">
      <div slot="mdBox" class="alert-modal ac">
        <div class="close" style="text-align: right;margin:10px auto;font-size: 50px;    margin-right: -20px;"
             @click="closeProcessDialog">
          <img src="../../static/images/close.png" width="70"/>
        </div>
        <div class="fs33 mt50 ac">{{ processMsg }}</div>
        <button class="button mt30" @click="closeProcessDialog">{{ $t('OK') }}</button>
      </div>
    </Dialog>

  </div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'

export default {
  components: {
    Header, Dialog
  },
  data() {

    return {
      detail: {},
      isShow: false,
      value: 50,
      imageShow: false,
      imageBase64: null,
      imageTpye: '',
      withScratch: false,
      isImgModel: false,
      isImage: true,
      score: 0,
      isShowResult: 1,
      processMsg: "",
      isType: '',
      productId:0,
      productDetail:{},
      topPanelTab: 'example',
    }
  },
  watch: {},
  computed: {
    normalizedImage() {
      const raw = (this.productDetail && this.productDetail.image) ? String(this.productDetail.image) : ''
      return raw.trim().replace(/^[`\s]+|[`\s]+$/g, '')
    }
  },
  mounted() {
    let that = this;
  },
  created() {
    if (this.$route.query.id) {
      this.productId = this.$route.query.id
      this.getProductInfo()
    }
    this.getHome();
  },
  methods: {
    getClick(item) {
      this.isType = item.key
    },
    getResult(type) {
      this.isShowResult = type
    },
    copy(item) {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    back() {
      this.$router.go(-1);
    },
    getHome() {
      let that = this;
      that.$api.get('/api/user/info', null, r => {
        that.$parent.returnCode(r, function () {
          that.score = r.data.score
        });
      })
    },
    getProductInfo(){
      let that = this;
      let data = {'id': that.productId}
      that.$api.post('/api/product/detail', data, r => {
        that.$parent.returnCode(r, function () {
          that.productDetail = r.data
        });
      })
    },

    getCharactersAfter(str, charToFind) {
      var index = str.indexOf(charToFind);
      if (index !== -1) {
        return str.slice(index + 1);
      }
      return ''; // 如果字符未找到，返回空字符串
    },
    convertToBase64(event) {
      const file = event.target.files[0];
      this.imageTpye = this.getCharactersAfter(file.type, '/');
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageBase64 = e.target.result;
          // 在这里可以将Base64字符串上传到服务器
          // this.uploadImage(this.imageBase64);
        };
        reader.readAsDataURL(file);
      }
    },
    convertToBase64_v2(event) {
      let that = this;
      const file = event.target.files[0];
      if (!file) return;
      // 原始大小（单位：KB）
      const originSizeKB = (file.size / 1024).toFixed(2);
      console.log("原始文件大小:", originSizeKB, "KB");
      // 1. 文件大小限制（5MB）
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        that.$refs.processDialog.showMaskFun();
        that.processMsg = this.$t('pic_size_limit')
        event.target.value = '';
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          // 2. 缩放尺寸
          const maxWidth = 800;
          const maxHeight = 800;
          let {width, height} = img;
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          // 3. PNG 自动转 JPEG
          let outputType = file.type.toLowerCase() === 'image/png' ? 'image/jpeg' : file.type;
          // 4. 压缩导出（JPEG 质量 0.7）
          this.imageBase64 = canvas.toDataURL(outputType, 0.7);
          // 5. 设置上传类型
          this.imageTpye = outputType.split('/')[1]; // e.g. "jpeg"
          // 计算压缩后的大小
          const compressedSize = this.base64Size(this.imageBase64);
          console.log("压缩后文件大小:", (compressedSize / 1024).toFixed(2), "KB");
        };
      };

      reader.readAsDataURL(file);
      event.target.value = '';
    },
    uploadImage() {
      let that = this
      if (!that.imageBase64) {
        that.$utils.alertText(that.$t('uploadTips'), 100);
        return;
      }
      let data = {
        image: {
          type: that.imageTpye,
          content: that.imageBase64
        },
        id: that.productId,
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/product/create', data, r => {
        that.$parent.loadModal(false);
        that.getHome()
        if (r.code == 0) {
          that.$refs.processDialog.showMaskFun();
          that.processMsg = r.msg
          return;
        }
        that.$parent.returnCode(r, function () {
          that.$refs.imgDialog.showMaskFun();
          that.imageShow = true
          that.detail = r.data
        });
      })
    },
    getImage() {
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.detail.url
      console.log(link.href)
      // link.target = '_blank'
      link.setAttribute('download', '文件名称')
      document.body.appendChild(link)
      link.click()
      window.open(this.detail.url, '_blank')

    },
    closeTmgDialog() {
      this.detail = {}
      this.$refs.imgDialog.closeMask();
    },
    closeProcessDialog() {
      this.processMsg = ""
      this.$refs.processDialog.closeMask();
    },
    goPurchaseChances() {
      this.$router.push({path: '/purchaseChances'})
    },
    // 辅助方法：计算 base64 图片大小
    base64Size(base64) {
      let str = base64.split(',')[1]; // 去掉前缀 data:image/jpeg;base64,
      let eqIndex = str.indexOf('=');
      if (eqIndex > 0) {
        str = str.substring(0, eqIndex); // 去掉填充字符
      }
      let length = str.length;
      return length * 3 / 4; // 得到字节数
    }
  }
}
</script>
<style scoped>
.faceimage-wrap {
  padding: 0.5rem 0.3rem;
  text-align: left;
}

.top-panel {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 0.22rem;
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}
.top-panel-tabs {
  display: flex;
  gap: 0.12rem;
  padding: 0.18rem 0.18rem 0.12rem;
}
.top-tab {
  flex: 1;
  text-align: center;
  font-size: 0.24rem;
  font-weight: 700;
  padding: 0.14rem 0;
  border-radius: 0.16rem;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.85);
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}
.top-tab.active {
  background: rgba(26, 75, 169, 0.2);
  color: #fff;
  border: 1px solid rgba(26, 75, 169, 0.45);
}
.top-panel-body {
  padding: 0.18rem;
}
.top-panel-desc {
  font-size: 0.26rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.88);
  max-height: 2.4rem;
  overflow: auto;
}
.sample-image-wrap {
  width: 100%;
  border-radius: 0.18rem;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.35);
}
.sample-image {
  display: block;
  width: 100%;
  height: auto;
}

.upload-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.2rem;
  padding: 0.22rem 0.2rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 0.22rem;
}
.upload-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
}
.pick-photo-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.1rem;
  padding: 0.18rem 0.32rem;
  background: rgba(26, 75, 169, 0.12);
  border: 1px dashed rgba(26, 75, 169, 0.55);
  border-radius: 0.18rem;
  color: #fff;
  font-size: 0.26rem;
  cursor: pointer;
  flex-shrink: 0;
  -webkit-tap-highlight-color: transparent;
}
.pick-photo-icon {
  width: 0.36rem;
  height: 0.36rem;
}
.hidden-input {
  display: none;
}
.thumb-preview {
  width: 0.96rem;
  height: 0.96rem;
  border-radius: 0.14rem;
  overflow: hidden;
  border: 2px solid rgba(26, 75, 169, 0.35);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  flex-shrink: 0;
}
.thumb-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.generate-btn {
  width: 90%;
  height: 0.9rem;
  background: linear-gradient(135deg, #1A4BA9 0%, #0d2e6e 100%);
  color: #fff;
  border-radius: 0.45rem;
  border: none;
  font-size: 0.32rem;
  font-weight: 700;
  box-shadow: 0 6px 20px rgba(26, 75, 169, 0.4);
  cursor: pointer;
  transition: all 0.3s;
  -webkit-tap-highlight-color: transparent;
}
.generate-btn:active {
  transform: scale(0.96);
  box-shadow: 0 2px 10px rgba(26, 75, 169, 0.4);
}
.generate-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chances-info-bar {
  display: flex;
  width: 100%;
  margin: 0 auto 0.4rem;
  background: rgba(255, 255, 255, 0.05);
  padding: 0.12rem 0.22rem;
  border-radius: 0.5rem;
  align-items: center;
  gap: 0.14rem;
}
.score-badge {
  display: flex;
  align-items: center;
  color: #fff;
  min-width: 0;
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
}
.score-badge span {
  white-space: nowrap;
}
.score-badge span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.buy-btn {
  background: #1A4BA9;
  border: none;
  color: #fff;
  padding: 0.12rem 0.24rem;
  border-radius: 0.3rem;
  font-size: 0.24rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(26, 75, 169, 0.3);
  -webkit-tap-highlight-color: transparent;
  flex: 0 1 48%;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
}
.buy-btn span {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.buy-btn img {
  flex: 0 0 auto;
}
.buy-btn:active {
  transform: scale(0.95);
}
.buy-icon {
  width: 0.28rem;
  margin-left: 0.15rem;
}
.mb30 { margin-bottom: 0.3rem; }
.score-badge .fs24 {
  line-height: 2.35;
  padding: 0.02rem 0;
}
</style>



// WEBPACK FOOTER //
// src/page/faceImage.vue